import { SolicitacaoAberturaResponse } from '../../models/solicitacao-servico.model';

export interface LinhaComprovante {
  rotulo: string;
  valor: string;
}

const DATA = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
const HORA = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });

/**
 * `2026-09-24T10:30:00` (sem fuso, como o ASP.NET serializa `DateTime` local) vira data local.
 * Nulo para texto vazio ou inválido.
 */
export function paraData(valor: string | null | undefined): Date | null {
  if (!valor) return null;

  const data = new Date(valor);

  return Number.isNaN(data.getTime()) ? null : data;
}

/** "24/09/2026 às 10:30", ou vazio. */
export function dataHora(valor: string | null | undefined): string {
  const data = paraData(valor);

  return data ? `${DATA.format(data)} às ${HORA.format(data)}` : '';
}

/** O solicitante como o back-end o gravou: o nome na identificada, "Anônimo" na anônima. */
function solicitante(resposta: SolicitacaoAberturaResponse): string {
  if (resposta.bitAnonimaSsv) return 'Anônimo';

  return resposta.desNomeSolicitanteSsv?.trim() || 'Identificado';
}

/**
 * As linhas do comprovante, montadas SÓ com o que a API devolveu no 201 — nada do formulário
 * digitado, que poderia divergir do que foi gravado. Função pura: é o conteúdo do PDF, testável
 * sem jsPDF.
 */
export function linhasComprovanteSolicitacao(resposta: SolicitacaoAberturaResponse): readonly LinhaComprovante[] {
  const linhas: LinhaComprovante[] = [
    { rotulo: 'Serviço', valor: resposta.desNomeServicoSsv },
    { rotulo: 'Situação', valor: resposta.desStatusSsv },
    { rotulo: 'Data de abertura', valor: dataHora(resposta.datInicioSsv) },
    { rotulo: 'Solicitante', valor: solicitante(resposta) },
  ];

  if (resposta.datAgendamentoSsv) {
    linhas.push({ rotulo: 'Atendimento', valor: dataHora(resposta.datAgendamentoSsv) });
  }

  if (resposta.desLocalAtendimentoSsv) {
    linhas.push({ rotulo: 'Local', valor: resposta.desLocalAtendimentoSsv });
  }

  linhas.push({ rotulo: 'Anexos enviados', valor: String(resposta.numAnexos) });

  return linhas;
}
